import { format } from "date-fns";
import { useEffect, useState } from "react";
import { BsEnvelope, BsFillTelephoneFill } from "react-icons/bs";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import orgApi from "../../api/org_api";
import { Breadcrumb, SearchInput, Table, Text } from "../../component/common";
import S from "../../Services/GeneralServices";
import { getTz } from "../../utils/CommonMethods";

type InterviewResultProps = { setLoading: Function };

const InterviewResult = ({ setLoading }: InterviewResultProps) => {
  const { type } = useParams();
  const [candidateList, setCandidateList] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearch(search);
    }, 1000);

    return () => {
      clearTimeout(timerId);
    };
  }, [search]);

  useEffect(() => {
    fetchSchedules();
  }, [debouncedSearch]);

  const fetchSchedules = async () => {
    setLoading(true);
    const userInfo = JSON.parse(
      localStorage.getItem("user__details")?.toString()!
    );
    const orgId = userInfo.id;
    const reqData = {
      type,
      search: debouncedSearch,
    };
    try {
      const res = await orgApi.fetchInterviewSchedule(orgId, reqData);

      if (res.data.success) {
        setCandidateList(res.data.schedule);
      } else {
        toast.error(res.data.msg);
      }
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong while fetching schedules");
    } finally {
      setLoading(false);
    }
  };



  const getTableData = () => {
    return {
      columns: [
        { label: "Candidate Details", accessor: "candidate_details" },
        { label: "Post Title", accessor: "post_title" },
        { label: "Interview Date", accessor: "interview_date" },
        { label: "Interview Time", accessor: "interview_time" },
        { label: "Status", accessor: "status" },
        {
          ...(S.getOrgDomain() !== "nam-it.com" && {
            label: "SIT Score",
            accessor: "sit_score",
          }),
        },
        { label: "Action", accessor: "action" },
      ],
      data:
        candidateList &&
        candidateList.length > 0 &&
        candidateList.map((value: any, index: number) => ({
          candidate_details: (
            <div
              key={index}
              className="flex flex-col items-start gap-1 truncate"
            >
              <Text
                className="font-semibold truncate max-w-44"
                text={value.candidate.first_name}
              />
              <p className="flex flex-row items-center gap-1 truncate">
                <BsEnvelope /> &nbsp;
                {value.candidate.email}
              </p>
              <p className="flex flex-row items-center gap-1">
                <BsFillTelephoneFill /> &nbsp;
                {value.candidate.mobile}
              </p>
            </div>
          ),
          post_title: <Text text={value.post.job_title} />,
          interview_date: (
            <Text text={format(value.utc_starttime, "dd MMM yyyy")} />
          ),
          interview_time: (
            <Text
              text={
                format(value.utc_starttime, "hh:mm a") +
                " to " +
                format(value.utc_endtime, "hh:mm a") +
                " " +
                getTz(value.candidate_tz)
              }
            />
          ),
          status: (
            <Text
              className={
                value.feedback[0].interview_status === "Completed"
                  ? "text-green-500"
                  : "text-red-500"
              }
              text={value.feedback[0].interview_status}
            />
          ),
          sit_score: (
            <Text
              className="text-green-500 "
              text={value.feedback[0].sit_score}
            />
          ),
          action: (
            <Text
              text="View Feedback"
              onClick={() => S.viewFeedback(value.id)}
              className="cursor-pointer text-blue-500 underline"
            />
          ),
        })),
    };
  };

  return (
    <>
      <div className="flex flex-col space-y-3">
        <div className="flex justify-between items-center ">
          <Breadcrumb
            items={[
              { text: "Dashboard", href: "/dashboard" },
              { text: "Interview Result", isActive: true },
            ]}
          />
          <SearchInput
            placeholder="Search.."
            value={search}
            onChange={(e) => setSearch(e)}
            onCancel={() => setSearch("")}
          />
        </div>
        <div className="">
          <Table
            columns={getTableData().columns}
            data={getTableData().data}
            containerHeight="h-[calc(100vh-140px)] 2xl:h-[calc(100vh-170px)]"
            isStickyHeader
          />
        </div>
      </div>
    </>
  );
};

export default InterviewResult;
